module.exports = __webpack_public_path__ + "img/duanwu_ps_16.c78d52c1.jpg";